/** Default landing route after sign-in (Top Competitor Filings → Insights). */
export const DEFAULT_APP_ROUTE = '/competitors?tab=Insights';

/**
 * Resolve where to send the user after login.
 * Preserves deep links (path + query + hash). Maps bare `/` or `/login` to the app default.
 */
export function getPostLoginRedirect(fromLocation) {
  if (!fromLocation?.pathname) return DEFAULT_APP_ROUTE;

  const path = `${fromLocation.pathname}${fromLocation.search || ''}${fromLocation.hash || ''}`;
  if (path === '/' || path === '/login') return DEFAULT_APP_ROUTE;

  return path;
}
